<template>
  <v-container fluid>
    <div class="text-xs-right mb-3">
      <v-btn @click="exportData" outline color="grey" class="ma-0 mb-1">
        <i class="fas fa-file-export mr-1"></i>
        {{ $t('export') }}
      </v-btn>
    </div>
    <date-filter
      v-model="selectedDate"
      :defaultFilter="'last_7_days'"
      @onSelected="getLoad"
    ></date-filter>
    <template v-if="loading">
      <v-layout fill-height align-center justify-center my-5>
        <div class="spinner text-xs-center" v-if="loading">
          <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
        </div>
      </v-layout>
    </template>
    <template v-else>
      <v-layout class="mb-3">
        <v-flex xs12 sm6 md4 class="pa-1">
          <v-card>
            <v-card-text>
              <div class="caption">Total</div>
              <div class="primary--text">{{ this.total }}</div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-1">
          <v-card>
            <v-card-text>
              <div class="caption">Qualify</div>
              <div class="primary--text">{{ this.qualify }}</div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md4 class="pa-1">
          <v-card>
            <v-card-text>
              <div class="caption">Other</div>
              <div class="primary--text">{{ this.other }}</div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers" :items="users" class="elevation-1">
        <template v-slot:items="props">
          <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
          <td>{{ props.item.userid ? props.item.userid : '-' }}</td>
          <td>{{ props.item.facebookname ? props.item.facebookname : '-' }}</td>
          <td>
            <v-chip v-if="props.item.qualificationstatus == 'Qualify'" color="green" small dark
              >Qualify</v-chip
            >
            <v-chip
              v-else-if="props.item.qualificationstatus == 'Not Qualify'"
              color="red"
              small
              dark
              >Not Qualify</v-chip
            >
            <v-chip v-else color="grey" small dark>n/a</v-chip>
          </td>
          <td>{{ props.item.occupation }}</td>
          <td>{{ props.item.basesalary | decimalFormat }}</td>
          <td>{{ props.item.othersalary | decimalFormat }}</td>
          <td>
            <!-- <template v-if="props.item.statusbureau == null"></template> -->
            <v-icon v-if="props.item.statusbureau" color="green">done</v-icon>
            <p v-else color="red">n/a</p>
          </td>
          <td v-if="props.item.closebureau">{{ props.item.closebureau }}</td>
          <td v-else>-</td>
          <td>{{ props.item.debtcardorploan | decimalFormat }}</td>
          <td>
            <!-- <template v-if="props.item.statuscarloan == null"></template> -->
            <v-icon v-if="props.item.statuscarloan" color="green">done</v-icon>
            <p v-else color="red">n/a</p>
          </td>
          <td>{{ props.item.carinstallment | decimalFormat }}</td>
          <td>
            <!-- <template v-if="props.item.statushomeloan == null"></template> -->
            <v-icon v-if="props.item.statushomeloan" color="green">done</v-icon>
            <p v-else color="red">n/a</p>
          </td>
          <td>{{ props.item.homeinstallment | decimalFormat }}</td>
          <td>
            {{
              ((props.item.homeinstallment ? parseFloat(props.item.homeinstallment) : 0) +
                (props.item.debtcardorploan ? parseFloat(props.item.debtcardorploan) : 0) +
                (props.item.carinstallment ? parseFloat(props.item.carinstallment) : 0))
                | decimalFormat
            }}
          </td>
          <td>
            <!-- <template v-if="props.item.statusoverdue == null"></template> -->
            <v-icon v-if="props.item.statusoverdue" color="green">done</v-icon>
            <p v-else color="red">n/a</p>
          </td>

          <td>
            <!-- <template v-if="props.item.issuccess == null"></template> -->
            <v-icon v-if="props.item.issuccess" color="green">done</v-icon>
            <v-icon v-else color="red">close</v-icon>
          </td>
          <td>{{ props.item.summarystatus ? props.item.summarystatus : '-' }}</td>
        </template>
      </v-data-table>
    </template>
    <div style="height: 60px"></div>
  </v-container>
</template>

<script>
import DateFilter from './DateFilter'
import dayjs from 'dayjs'
import api from '@/api'
import XLSX from 'xlsx'
import numeral from 'numeral'

export default {
  data() {
    return {
      loading: true,
      headers: [
        {
          text: 'Time',
          value: 'timestamp'
        },
        {
          text: 'Facebook ID',
          value: 'userid'
        },
        {
          text: 'Facebook Name',
          value: 'facebookName'
        },
        {
          text: 'Qualification Status',
          value: 'qualificationstatus'
        },
        {
          text: 'Occupation',
          value: 'occupation'
        },
        {
          text: 'Salary',
          value: 'basesalary'
        },
        {
          text: 'Other Salary',
          value: 'othersalary'
        },
        {
          text: 'Bureau Status',
          value: 'statusbureau'
        },
        {
          text: 'Close Bureau',
          value: 'closebureau'
        },
        {
          text: 'Credit card debt and Personal debt',
          value: 'debtcardorploan'
        },
        {
          text: 'Car Loan Status',
          value: 'statuscarloan'
        },
        {
          text: 'Car Installment',
          value: 'carinstallment'
        },
        {
          text: 'Home Loan Status',
          value: 'statushomeloan'
        },
        {
          text: 'Home Installment',
          value: 'homeinstallment'
        },
        {
          text: 'Total Debt',
          value: 'totaldebt'
        },
        {
          text: 'Over Due Status',
          value: 'statusoverdue'
        },
        {
          text: 'Success',
          value: 'issuccess'
        },
        {
          text: 'Summary Status',
          value: 'summarystatus'
        }
      ],
      users: [],
      total: 0,
      qualify: 0,
      other: 0,
      selectedDate: {
        start: dayjs()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      }
    }
  },
  async mounted() {
    await this.getLoad()
  },
  components: {
    DateFilter
  },
  methods: {
    exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'usersummary'

      var json = []

      json = this.users.map(el => {
        return {
          Time: dayjs(el.timestamp).format('DD/MM/YYYY HH:mm'),
          'Facebook ID': el.userid ? el.userid : '-',
          'Facebook Name': el.facebookname ? el.facebookname : '-',
          'Qualification Status': el.qualificationstatus ? el.qualificationstatus : 'n/a',
          Occupation: el.occupation ? el.occupation : '-',
          Salary: numeral(el.basesalary).format('0,0.00'),
          'Other Salary': numeral(el.othersalary).format('0,0.00'),
          'Bureau Status': el.statusbureau ? 'Yes' : 'No',
          'Close Bureau': el.closebureau ? el.closebureau : '-',
          'Credit card debt and Personal debt': numeral(el.debtcardorploan).format('0,0.00'),
          'Car Loan Status': el.statuscarloan ? 'Yes' : 'No',
          'Car Installment': numeral(el.carinstallment).format('0,0.00'),
          'Home Loan Status': el.statushomeloan ? 'Yes' : 'No',
          'Home Installment': numeral(el.homeinstallment).format('0,0.00'),
          'Total Debt':
            (el.homeinstallment ? parseFloat(el.homeinstallment) : 0) +
            (el.debtcardorploan ? parseFloat(el.debtcardorploan) : 0) +
            (el.carinstallment ? parseFloat(el.carinstallment) : 0),
          'Over Due Status': el.statusoverdue ? 'Yes' : 'No',
          Success: el.issuccess ? 'Yes' : 'No',
          'Summary Status': el.summarystatus ? 'Yes' : 'No'
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    async getLoad() {
      this.loading = true
      try {
        var response = await this.getNeoMoneyDashboard()
        this.total = response.data.length
        var qualified = response.data.filter(el => {
          return el.qualificationstatus == 'Qualify'
        })
        this.qualify = qualified.length
        this.other = this.total - this.qualify
        this.users = response.data
      } catch (error) {
        this.users = []
        this.total = 0
        this.qualify = 0
        this.other = 0
      }
      this.loading = false
    },
    getNeoMoneyDashboard() {
      var data = {
        datefrom: this.selectedDate.start,
        dateto: this.selectedDate.end
      }
      return new Promise((resolve, reject) => {
        api.getNeoMoneyDashboard(data, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/NeoMoneyUserSummary.vue